import React from "react";
import { Popover } from "antd";
import TreeIcon from "../../components/Icons/treeIcon.js";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

export const StatisticCell = ({
  children,
  label,
  controls,
  note,
  progress,
  tooltip,
}: {
  children: any;
  label: string;
  note?: string;
  controls?: any;
  progress?: any;
  tooltip?: string;
}) => (
  <div className="statistic-row__cell">
    {(label || controls) && (
      <div className="statistic-row__label-row">
        {label && (
          <div className="statistic-row__label-cell">
            <div className="statistic-row__label">
              {label}
              {tooltip && (
                <Tooltip placement="topLeft" arrowPointAtCenter title={tooltip}>
                  <QuestionCircleOutlined className="icon icon--interactive statistic-row__label-tooltip" />
                </Tooltip>
              )}
                
              </div>
          </div>
        )}
        {controls && (
          <div className="statistic-row__label-cell">
            <Popover
              placement="topRight"
              trigger="click"
              title="Site plan details"
              content={controls}
            >
              <button className="statistic-row__text-button">
                <TreeIcon />
                <span className="statistic-row__text-button-label">Adjust</span>
              </button>
            </Popover>
          </div>
        )}
      </div>
    )}
    <div className="statistic-row__content">{children}</div>
    {note && <div className="statistic-row__note">{note}</div>}
    {progress && <div>{progress}</div>}
  </div>
);
